module.exports = __webpack_public_path__ + "img/edit-confirm.4517e93d.png";